import { types } from "../action-types";

const initialState = {
  loading: false,
  details: [],
  matches: [],
  interviews: [],
  error: false,
  reminders: [],
};

const dashbaordReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DASHBOARD_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_DASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
      };
    case types.GET_DASHBOARD_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        details: [],
        error: true,
      };
    case types.GET_DASHBOARD_INTERVIEWS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_DASHBOARD_INTERVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        interviews: action.payload,
        error: false,
      };
    case types.GET_DASHBOARD_INTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        interviews: [],
        error: true,
      };
    case types.GET_DASHBOARD_MATCHES_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_DASHBOARD_MATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        matches: action.payload,
        error: false,
      };
    case types.GET_DASHBOARD_MATCHES_FAILURE:
      return {
        ...state,
        loading: false,
        matches: [],
        error: true,
      };
    case types.GET_REMINDERS_SUCCESS:
      return {
        ...state,
        reminders: action.payload,
      };
    default:
      return state;
  }
};

export default dashbaordReducer;
